module.exports = __webpack_public_path__ + "img/03.2335734f.png";